import _ from 'lodash'
import styles from './index.css'
import cx from 'classnames'

import { FormRow } from '../../../../Common/Form'
import ProductAttribute from './ProductAttribute'
import CategorySelectorFields
  from '../../../Common/ProposalForm/CategorySelector/CategorySelectorField'
import {
  IconPopoverLabel
} from '../../../Common/ProposalForm/FormLabelTooltip/FormLabelTooltip'
import { PROPOSAL_TYPE, PROPOSAL_PHASE_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'
import { Field } from '../../../../Common/forms'
import { AttrClusterMenuSelectField } from './AttrClusterMenuSelectField'
import { PopoverImg } from '@vzmi/shp_shared_compo'

const getAttrInfoSubTitle = proposalType => {
  let proposalTypeLabel = ''

  switch (proposalType) {
    case PROPOSAL_TYPE.NEW_LISTING: {
      proposalTypeLabel = '賣場'
      break
    }
    case PROPOSAL_TYPE.NEW_PRODUCT: {
      proposalTypeLabel = '商品'
      break
    }
    default: {
      return null
    }
  }

  return `(與設定${proposalTypeLabel}類別)`
}

const AttributeInfo = props => {
  const {
    actions: {
      fetchCategoryOptions,
      fetchStruDataAttrClusterOptions,
      fetchRecentlyCategoryOptions
    },
    triggerFieldChange,
    syncTransientAttributes,
    proposalType,
    phase,
    mismatchedCluster,
    candidateStruDataClusterList = [],
    productStruDataAttrClusterId,
    readOnly,
    isPM,
    meta,
    mustShowFormError,
    showErrorOnActive,
    onRecentlyAttributesChange
  } = props

  const attrInfoSubTitle = getAttrInfoSubTitle(proposalType)

  const isUpdateAttribute = proposalType === PROPOSAL_TYPE.UPDATE_ATTRIBUTE

  const options = candidateStruDataClusterList.map(struDataCluster => {
    const {
      id,
      name
    } = struDataCluster

    return {
      ...struDataCluster,
      label: name,
      value: id
    }
  })

  const hasMultipleAttrCluster = isUpdateAttribute && options.length > 1
  // api 查無賣場設定的規格表
  const isClusterNotFound = (
    phase === PROPOSAL_PHASE_TYPE.COMPOSE &&
    isUpdateAttribute &&
    (
      _.isEmpty(_.get(candidateStruDataClusterList, '0')) ||
      _.isNil(productStruDataAttrClusterId)
    )
  )

  return (
    <div
      className={styles.AttributeInfo}
      data-role='attribute-info'
    >
      <FormRow
        label='選擇規格表'
        labelAlign='top'
        subTitle={attrInfoSubTitle}
      >
        <CategorySelectorFields
          fetchRecentlyCategoryOptions={fetchRecentlyCategoryOptions}
          fetchCategoryOptions={fetchCategoryOptions}
          fetchStruDataAttrClusterOptions={fetchStruDataAttrClusterOptions}
          triggerFieldChange={triggerFieldChange}
          proposalType={proposalType}
          // 查無規格表的情況下需要可以重新選擇規格表
          readOnly={isClusterNotFound ? false : readOnly}
          phase={phase}
          mismatchedCluster={mismatchedCluster}
          isPM={isPM}
          hasMultipleAttrCluster={hasMultipleAttrCluster}
          mustShowFormError={mustShowFormError}
          onRecentlyAttributesChange={onRecentlyAttributesChange}
        />
        {
          hasMultipleAttrCluster && (
            <Field
              closeOnSelect
              closeOnCustomInputSubmit
              options={options}
              triggerFieldChange={triggerFieldChange}
              name={'product.struDataAttrClusterId'}
              placeholder='-- 請選擇規格表 --'
              // disabled={readOnly}
              component={AttrClusterMenuSelectField}
              enableCustomInput={false}
              menuInputPlaceholder='搜尋關鍵字'
              // validate={validateAttrItem(isRequired, `請選擇${name}`)}
              className={cx(styles.attributeItemInput, styles.attributeItemSelect)}
              popupClassName={cx(styles.attributeItemInput, styles.attributeItemSelectPopup)}
              showErrorOnActive={showErrorOnActive}
              mustShowFormError={mustShowFormError}
            />
          )
        }
      </FormRow>
      <FormRow
        labelAlign='top'
        label={(
          <IconPopoverLabel
            popoverContent={(
              <PopoverImg
                url={`${CDN}/img/tooltip_value.png`}
                width={500}
                height={400}
              />
            )}
          >
            商品屬性
          </IconPopoverLabel>
        )}
      >
        <ProductAttribute
          proposalType={proposalType}
          triggerFieldChange={triggerFieldChange}
          syncTransientAttributes={syncTransientAttributes}
          fetchRecentlyCategoryOptions={fetchRecentlyCategoryOptions}
          fetchCategoryOptions={fetchCategoryOptions}
          fetchStruDataAttrClusterOptions={fetchStruDataAttrClusterOptions}
          meta={meta}
          showErrorOnActive={showErrorOnActive}
          mustShowFormError={mustShowFormError}
          isClusterNotFound={isClusterNotFound}
        />
      </FormRow>
    </div>
  )
}

export default AttributeInfo
